import React, { useState } from "react";
import { cn } from "../../../Utils/helper";

const CarouselView = ({ data, onFinish }) => {
  const [currentStep, setCurrentStep] = useState(0);
  const steps = data.steps || [];
  const stepData = steps[currentStep];
  const isLastStep = currentStep === steps.length - 1;

  const handleNext = () => {
    if (!isLastStep) {
      setCurrentStep((prev) => prev + 1);
    } else {
      onFinish();
    }
  };

  const handlePrev = () => {
    if (currentStep > 0) setCurrentStep((prev) => prev - 1);
  };

  return (
    <div className="flex flex-col gap-4 h-full w-full px-6 py-9">
      {/* Header */}
      <div className="flex flex-col gap-4 xs:gap-6 text-center">
        <p className="text-[#253FF6] font-bold text-xs xs:text-sm">
          {stepData.subTitle}
        </p>
        <p className="text-xl xs:text-2xl font-bold text-[#253FF6]">
          {stepData.title}
        </p>
      </div>

      {/* Image */}
      <div className=" flex flex-1 flex-col gap-4 xs:gap-6 justify-center items-center">
        <img
          key={stepData.id}
          src={stepData.image}
          alt={stepData.title}
          className="h-[350px] xs:h-[400px] w-[209px] object-contain animate-fade-in-up transition-all duration-300"
        />
      </div>

      {/* Description */}
      <div className="text-black text-sm xs:text-base flex items-center justify-center text-center">
        {stepData.description}
      </div>

      {/* Navigation Controls */}
      <div className="grid grid-cols-[40px_1fr_40px] items-center mt-auto">
        {/* Prev Button */}
        <div className="flex justify-start">
          {currentStep > 0 && (
            <button onClick={handlePrev} className="p-1.5 text-[#253FF6]">
              <span className="icon icon-arrow-left text-[18px]" />
            </button>
          )}
        </div>

        {/* Dots */}
        <div className="flex justify-center items-center space-x-2">
          {steps.map((_, index) => (
            <div
              key={index}
              className={cn(
                "rounded-full transition-all duration-300",
                index === currentStep
                  ? "w-2.5 h-2.5 bg-[#A0A0A0]"
                  : "w-[5px] h-[5px] bg-[#E9E6E4]",
              )}
            />
          ))}
        </div>

        {/* Next/Finish Button */}
        <div className="flex justify-end">
          <button onClick={handleNext} className="p-1.5 text-[#253FF6]">
            <span
              className={cn(
                "icon text-[18px] transition-colors duration-300 ease-in-out",
                isLastStep ? "icon-check text-[22px]" : "icon-arrow-right",
              )}
            />
          </button>
        </div>
      </div>
    </div>
  );
};

export default CarouselView;
